import React, { useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../../../../../api/baseUrl";
import getDecryptedToken from "../../../../../../../../api/getDecryptedToken";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddSubTreatmentModel from "./AddSubTreatmentModel";
import AllSubTreatmentTr from "./AllSubTreatmentTr";
import { insertBreaks } from "../../../../../../../../utils/functions/resize";


const user: string | undefined = getDecryptedToken("userName");
function AllMainTreatmentTr({
  item,
  onClick,
  refresh,
  handleAddSubTreatmentModal,
}: any) {
  const dateNow = new Date();
  const { ID } = useParams();

  const [status, setstatus] = useState(item?.status);

  const handleSelect = (e: any) => {
    if (item?._id) {
      setstatus(e.target.value);
      baseUrl
        .post(
          "treatment/add-TreatmentStatus",
          { status: e.target.value },
          {
            headers: {
              treatmentid: ID,
              treatmentsid: item._id,
            },
          }
        )
        .then((response) => {
          refresh();
        })
        .catch((error) => {
          console.log(error);
        });
      
    }
  };
  const handleSelectClick = () => {
    if (item?._id === undefined) {
      refresh();
    }
  };

  // const now = new Date();
  // const offset = now.getTimezoneOffset(); // in minutes
  // const hours = Math.floor(Math.abs(offset) / 60);
  // const minutes = Math.abs(offset) % 60;
  // const gmtSign = offset <= 0 ? '+' : '-';
  // console.log(`GMT${gmtSign}${hours}:${minutes < 10 ? '0' + minutes : minutes}`);

  return (
    <tr className="hover:bg-slate-50 transition-colors">
      <td className="px-4 py-3 text-sm text-slate-600">
        {new Date(item?.createdAt)
          ? new Date(item?.createdAt).toISOString()?.split("T")[0]
          : new Date(dateNow).toISOString().split("T")[0]}
      </td>
      <td className="px-4 py-3 text-sm font-medium text-slate-800">
        {item?.treatment}
        {item?.type ? " - " + item?.type : ""}
        {item?.subtype ? " - " + item?.subtype : ""}
      </td>
      <td className="px-4 py-3 text-sm text-slate-600">{item?.toothNo}</td>
      <td className="px-4 py-3 text-sm text-slate-600">{item?.surface}</td>
      <td className="px-4 py-3 text-sm text-slate-600">{item?.quantity}</td>
      <td className="px-4 py-3 text-sm font-medium text-slate-800">Rs {item?.price}</td>
      <td className="px-4 py-3" onClick={handleSelectClick}>
        <select
          value={status}
          onChange={handleSelect}
          className={`px-2 py-1 rounded-lg text-xs font-medium border-0 cursor-pointer ${
            status === "Complete"
              ? "bg-emerald-100 text-emerald-700"
              : status === "ongoing"
              ? "bg-amber-100 text-amber-700"
              : "bg-slate-100 text-slate-600"
          }`}
        >
          {!item?.paid && <option value="planned">Planned</option>}
          <option value="ongoing">Ongoing</option>
          <option value="Complete">Complete</option>
        </select>
      </td>
      <td className="px-4 py-3 text-sm text-slate-600">
        {item?.didBy
          ? item?.didBy?.firstName + " " + (item?.didBy?.lastName ?? "")
          : user}
      </td>
      <td className="px-4 py-3 text-sm text-slate-500 max-w-[150px] truncate">{insertBreaks(item?.note)}</td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <button
            onClick={() => handleAddSubTreatmentModal(item?._id)}
            className="w-8 h-8 rounded-lg bg-indigo-100 text-indigo-600 hover:bg-indigo-200 flex items-center justify-center transition-colors"
            title="Add treatment record"
          >
            <AddCircleIcon sx={{ fontSize: 18 }} />
          </button>
          {!item?.paid && (
            <button
              onClick={onClick}
              className="w-8 h-8 rounded-lg bg-red-100 text-red-600 hover:bg-red-200 flex items-center justify-center transition-colors"
            >
              <DeleteOutlineIcon sx={{ fontSize: 18 }} />
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}

export default AllMainTreatmentTr;
